export default "__VITE_ASSET__Dil9wDLE__"